import { Component } from '@angular/core';

@Component({
    selector: 'stby-modal-cta',
    styleUrl: './modal-cta.scss',
    templateUrl: './modal-cta.html',
})
export class ModalCta {}
